(function ($) {
    $(document).ready(function () {

        console.log('Archives!');

        const url = new URL(location.href);

        var searchstring = url.searchParams.get('search');

        if(searchstring){
            if($('#post-archive-search').length){
                $('#post-archive-search').val(searchstring);
            }
        }



        $("#post-archive-filter-form")
            .on("change", "select.form-control", function () {

                checkClearFilterBtnVisibility();

                // loadMorePosts(true);

                updateWindowHref();

            });

        if ($(".btn-clear-filter", "#post-archive-filter-form").length > 0) {

            checkClearFilterBtnVisibility();

            $(".btn-clear-filter", "#post-archive-filter-form").on("click", function (evt) {

                evt.preventDefault();

                $("#post-archive-filter-form").find("input[type='search'], .form-control").each(function () {
                    $(this).val("");
                });

                // Clear query string
                let clearedUrl = window.location.href.replace(window.location.search, "?paged=1").replace('#038;date&tags','');

                window.history.replaceState({path: clearedUrl}, "", clearedUrl);

                $(this).hide();
                location.reload();

            });

        }

        function updateWindowHref(){

            let newFilterUrl = "?" + $("#post-archive-filter-form").serialize() + "&paged=1" .replace('#038;date&tags','') + "#archive-listing-anchor";

            window.history.replaceState({path: newFilterUrl}, "", newFilterUrl);
            location.reload();

        }


        function checkClearFilterBtnVisibility() {

            let filterFormEmpty = true;

            $("#post-archive-filter-form").find("input[type='search'], .form-control").each(function () {

                // If any filter fields have a value, show the clear button
                if ($(this).val() !== "") {
                    filterFormEmpty = false;
                }

            });

            // If the filter form doesn't have any values set, hide the clear filter button
            if (filterFormEmpty) {

                $(".btn-clear-filter", "#post-archive-filter-form").hide();

                // Otherwise, show it
            } else {

                $(".btn-clear-filter", "#post-archive-filter-form").show();

            }

        }

    });

})(jQuery);